import { sync, registerModule } from 'vuex-pathify';
import globalState from '@/store/modules/layoutElement';

// https://davestewart.github.io/vuex-pathify/#/guide/component?id=registermodule

const getOptions = name =>
  registerModule(name, globalState, () => {
    return {
      computed: sync(name + '/*'),
    };
  });

export default name => {
  return {
    extends: getOptions(name),
    updated() {
      const newHooks = getOptions(name);
      this.$nextTick(vm => {
        if (!vm) return;
        newHooks.destroyed.bind(vm)();
        newHooks.beforeCreate.bind(vm)();
      });
    },
  };
};
